export const getDeviceByIdSelector = (state, props) => {
  const deviceId = props.match && props.match.params && props.match.params.id;
  //device.id is a number in mock data (not sure what comes from server) so change it to string before comparison to deviceId (string from url)
  return (
    (state.mfa.devices &&
      state.mfa.devices.find(device => device.id + "" === deviceId)) ||
    {}
  );
};
